import { AxiosError } from "axios";
import { useLocale } from "next-intl";
import { useMutation } from "react-query";
import { user } from "@/services/user";
import { useRouter } from "next/router";
import { setMyCookie } from "@/helper/helper";
import { useSolutionsSelect } from "@/states/solution.state";
import { useError, useShowRenewalSubscriptionPopup } from "@/states/common.state";
import { useQrShowState } from "@/states/qr.state";
import { useUserState } from "@/states/user.state";
import { cookiePersistStorage } from "@/helper/common.helper";

type useRegisterType = {
  via_signature?: boolean;
  setFocus?: (val: boolean) => void;
  onSuccessCb?: () => void;
};
const useRegister = ({ via_signature, setFocus, onSuccessCb }: useRegisterType = {}) => {
  const { postRegister } = user;
  const { setSolutionsType, solutionsSelectedTypes } = useSolutionsSelect.getState();

  const { setDownloadQrId, dashboardQr, destroyDashboardQr } = useQrShowState.getState();
  const { destroyShowRenewalSubscriptionPopup } = useShowRenewalSubscriptionPopup.getState();
  const router = useRouter();
  const { setUser, guestToken } = useUserState.getState();
  const locale = useLocale();

  const { mutate: setMutate, isLoading, isSuccess } = useMutation(
    (params: Record<string, any>) =>
      postRegister({ ...params, qrcode: { ...dashboardQr }, via_signature }),
    {
      onSuccess: async ({ data, redirect, qrcode, qrType = "", ...rest }) => {

        onSuccessCb && onSuccessCb();

        setSolutionsType({ solutionSelectedType: qrType ?? solutionsSelectedTypes });

        setUser(data);
        destroyShowRenewalSubscriptionPopup();
        if (via_signature) {
          destroyDashboardQr();
          const redirectUrl = new URL(`${process.env.NEXT_PUBLIC_SITE_MAIN_URL}signature-auth`);
          Object.entries(rest).map(([key, val]) =>
            redirectUrl.searchParams.append(key, val as string),
          );
          redirectUrl.searchParams.append("guestToken", guestToken?.toString() || "");
          redirectUrl.searchParams.append("type", solutionsSelectedTypes || "");
          redirectUrl.searchParams.append("redirect", redirect || "");
          redirectUrl.searchParams.append("qrcode", qrcode || "");
          redirectUrl.searchParams.append("locale", locale || "en");
          window.location.href = redirectUrl.toString();
          return;
        }
        setMyCookie("access_token", data.tokens.access_token, 20);
        if (redirect) {
          cookiePersistStorage.setItem("redirect_url_after_auth", redirect);
          setDownloadQrId(qrcode || null);
          router.push(process.env.NEXT_PUBLIC_SITE_MAIN_URL + redirect);
          return;
        }
      },
      onError: ({ response }: AxiosError) => {
        const { setError } = useError.getState();
        setError(response?.data?.errors);

        if (response?.data?.errors.password && response?.data?.errors.email) {
          if (setFocus) {
            setFocus(false);
          }
          return;
        } else {
          if (setFocus) {
            setFocus(false);
          }
        }
      },
    },
  );

  return {
    setMutate,
    isLoading,
    isSuccess
  };
};

export default useRegister;
